import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation9({ animation, badge, all_animations }: Props) {
  const [showBadge, setShowBadge] = useState(false)
  const [showText, setShowText] = useState(false)

  useEffect(() => {
    setTimeout(() => setShowBadge(true), 200)
    setTimeout(() => setShowText(true), 1000)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes bounceIn {
          0% {
            transform: scale(0) rotate(-180deg);
            opacity: 0;
          }
          50% {
            transform: scale(1.3) rotate(10deg);
          }
          70% {
            transform: scale(0.9) rotate(-5deg);
          }
          85% {
            transform: scale(1.1) rotate(2deg);
          }
          100% {
            transform: scale(1) rotate(0deg);
            opacity: 1;
          }
        }
        @keyframes bounceInText {
          0% {
            transform: translateY(50px) scale(0);
            opacity: 0;
          }
          60% {
            transform: translateY(-20px) scale(1.2);
            opacity: 1;
          }
          80% {
            transform: translateY(10px) scale(0.9);
          }
          100% {
            transform: translateY(0) scale(1);
          }
        }
        @keyframes shine {
          0% { left: -100%; }
          100% { left: 100%; }
        }
        .bounce-in {
          animation: bounceIn 1s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;
        }
        .bounce-in-text {
          animation: bounceInText 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;
        }
        .shine-effect {
          position: relative;
          overflow: hidden;
        }
        .shine-effect::after {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 50%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
          animation: shine 2s infinite;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh]">
        {/* Badge qui rebondit */}
        <div className={`${showBadge ? 'bounce-in' : 'opacity-0'}`}>
          <div className="shine-effect w-48 h-48 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/50 transform rotate-3">
            <span className="text-6xl sm:text-8xl">{badge.emoji}</span>
          </div>
        </div>

        {/* Texte qui apparaît */}
        <div className={`mt-6 text-center ${showText ? 'bounce-in-text' : 'opacity-0'}`}>
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow">{badge.name}</div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
        </div>

        <div className={`mt-4 text-tessan-cream/70 text-center max-w-[280px] sm:max-w-xs transition-all duration-500 delay-1000 ${showText ? 'opacity-100' : 'opacity-0'}`}>
          {badge.description}
        </div>
      </div>
    </AnimationLayout>
  )
}
